import discussionRoomFileLogo from '../../../../assets/discussion-room-file-logo.png'

const RoomDiscussionInfo = ({sessionData, role, infoRef}) => {
	console.log("sessionData", sessionData)
	const options = { year: 'numeric', month: 'long', day: 'numeric' };
	let startTime =sessionData['waktu_mulai'].split(" ")[1];
	let endTime =sessionData['waktu_akhir'].split(" ")[1];
	let date = new Date(sessionData['waktu_mulai'].split(" ")[0]);
	let fileName = sessionData.file_materi_diskusi.split("/")
	fileName = fileName[fileName.length-1]
	date = date.toLocaleDateString('en-GB', options)
	let ketentuanDiskusiList = []
    let pemicuDiskusiList = []
	if(sessionData['ketentuan_diskusi'] !== null){
        ketentuanDiskusiList = sessionData['ketentuan_diskusi'].split('\r\n')
    }
	if(sessionData['pemicu_diskusi'] !== null ){
        pemicuDiskusiList = sessionData['pemicu_diskusi'].split('\r\n')
    }
	return (
		<div className='discussion-room-info discussion-room-card' ref={infoRef}>
			{
				sessionData !== null &&
				<>
					<div className="discussion-info-container">
						<h3 className="wiyata-blue-text discussion-info-matkul">
							{sessionData['mata_kuliah']}
						</h3>
						<p className="discussion-info-date">
							{date}
						</p>
						<p className="discussion-info-date">
							{`${sessionData['topik_diskusi']} (${startTime} - ${endTime})`}
						</p>
						{pemicuDiskusiList.length > 0 ? 
							<div className="ketentuan-diskusi">
								{pemicuDiskusiList.map((pemicu,index)=>
									<p className="pemicu-diskusi-content" key={index}>{pemicu}</p>
								)}
							</div>
						:null}
						{ketentuanDiskusiList.length > 0 ? 
							<div className="ketentuan-diskusi">
								<p className="ketentuan-diskusi-title">
									Discussion terms:
								</p>
								{ketentuanDiskusiList.map((ketentuan,index)=>
									<p className="ketentuan-diskusi-content" key={index}>{ketentuan}</p>
								)}
							</div>
						:null}
						{sessionData['file_materi_diskusi'] != '/media/null' ? 
							<a
								href={`https://backend-ta-wiyata.herokuapp.com${sessionData.file_materi_diskusi}`} 
								target="_blank" 
								className='file-materi-diskusi-wrapper'
								rel="noopener noreferrer">
								<div className="file-materi-diskusi">
									<img 
										className="file-diskusi-logo" 
										src={discussionRoomFileLogo} 
										alt="file diskusi logo"
										/>
									<p className="file-materi-diskusi-content">
										{fileName}
									</p>
								</div>
							</a>
							
						:null}
					</div>
				</>
			}
			{
				sessionData === null &&
				<div>Loading...</div>
			}
		</div>
	);
}
 
export default RoomDiscussionInfo;